module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('page-content', {
    attrs: {
      "page-title": "Dashboard Parking"
    }
  }, [_c('md-list', [_c('md-list-item', [_c('md-avatar', {
    staticClass: "md-avatar-icon md-primary"
  }, [_c('md-icon', [_vm._v("insert_drive_file")])], 1), _vm._v(" "), _c('div', {
    staticClass: "md-list-text-container"
  }, [_c('span', [_vm._v("Vacation Itinerary")]), _vm._v(" "), _c('p', [_vm._v("Jan 20, 2014")])]), _vm._v(" "), _c('md-button', {
    staticClass: "md-icon-button md-list-action"
  }, [_c('md-icon', [_vm._v("info")])], 1)], 1), _vm._v(" "), _c('md-list-item', [_c('md-avatar', {
    staticClass: "md-avatar-icon md-primary",
    attrs: {
      "md-theme": "orange"
    }
  }, [_c('md-icon', [_vm._v("collections")])], 1), _vm._v(" "), _c('div', {
    staticClass: "md-list-text-container"
  }, [_c('span', [_vm._v("Kitchen Remodel")]), _vm._v(" "), _c('p', [_vm._v("Jan 10, 2014")])]), _vm._v(" "), _c('md-button', {
    staticClass: "md-icon-button md-list-action"
  }, [_c('md-icon', [_vm._v("info")])], 1)], 1), _vm._v(" "), _c('md-list-item', [_c('md-avatar', {
    staticClass: "md-avatar-icon md-primary",
    attrs: {
      "md-theme": "green"
    }
  }, [_c('md-icon', [_vm._v("view_list")])], 1), _vm._v(" "), _c('div', {
    staticClass: "md-list-text-container"
  }, [_c('span', [_vm._v("Grocery Shop")]), _vm._v(" "), _c('p', [_vm._v("Jan 10, 2014")])]), _vm._v(" "), _c('md-button', {
    staticClass: "md-icon-button md-list-action"
  }, [_c('md-icon', [_vm._v("info")])], 1)], 1), _vm._v(" "), _c('md-list-item', [_c('md-avatar', {
    staticClass: "md-avatar-icon md-primary",
    attrs: {
      "md-theme": "orange"
    }
  }, [_c('md-icon', [_vm._v("collections")])], 1), _vm._v(" "), _c('div', {
    staticClass: "md-list-text-container"
  }, [_c('span', [_vm._v("Weekend Pictures")]), _vm._v(" "), _c('p', [_vm._v("Jan 10, 2014")])]), _vm._v(" "), _c('md-button', {
    staticClass: "md-icon-button md-list-action"
  }, [_c('md-icon', [_vm._v("info")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-4f3c9fa8!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Dashboard.vue
// module id = 559
// module chunks = 83